import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore, UserRole } from '../../stores/authStore';

interface SalesRouteProps {
  children: React.ReactNode;
}

const SalesRoute: React.FC<SalesRouteProps> = ({ children }) => {
  const { user } = useAuthStore();

  // Check if user has access to Sales page
  const hasSalesAccess = user && (
    user.role === UserRole.ACCOUNT_MANAGER ||
    user.role === UserRole.ADMIN ||
    user.role === UserRole.SUPER_ADMIN ||
    user.hasAdminAccess ||
    user.hasAuditAccess // Auditors can access all pages
  );

  if (!hasSalesAccess) {
    // Redirect to dashboard if user doesn't have sales access
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default SalesRoute;
